import { render, staticRenderFns } from "./SignScreenShow_static.vue?vue&type=template&id=19dc45f2&"
import script from "./SignScreenShow_static.vue?vue&type=script&lang=js&"
export * from "./SignScreenShow_static.vue?vue&type=script&lang=js&"
import style0 from "./SignScreenShow_static.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports